import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Well, FormHeading } from '../../../form';
import QrCodeReader from '../../../qrCodeReader';
import { RegisterBadgeForm } from './RegisterBadgeForm';
import { IRegisterBadgeFormValues } from './types';

const initialValues: IRegisterBadgeFormValues = {
  description: '',
};

const RegisterBadgePage: React.FC = () => {
  const history = useHistory();

  const [badgeNumber, setBadgeNumber] = useState<string>('');

  const redirectToList = (): void => history.replace('/reception/badges');

  return (
    <Container>
      <Well>
        <FormHeading title="Register new badge" />
        {badgeNumber && (
          <RegisterBadgeForm
            initialValues={initialValues}
            badgeNumber={badgeNumber}
            onSubmitted={redirectToList}
            onCancel={redirectToList}
          />
        )}
        <QrCodeReader
          backUrl="/reception/badges"
          mode="register"
          onSuccess={setBadgeNumber}
        />
      </Well>
    </Container>
  );
};

export default RegisterBadgePage;
